import { ProfileColor } from "../../../dispatch/src/ProfileColor";
import { Checkbox, DataSource, DateRangeFilter, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanningProfile extends Layout {
    checkBrokerageStatusExclude: Checkbox;
    checkDispatcherUserIdExclude: Checkbox;
    checkOperationsUserExclude: Checkbox;
    checkOrderCustomersExclude: Checkbox;
    checkOrderIbExclude: Checkbox;
    checkOrderObExclude: Checkbox;
    checkOrderSalespersonExclude: Checkbox;
    checkOrderTrailerTypeExclude: Checkbox;
    checkOrderTypeExclude: Checkbox;
    checkRevenueCodeExclude: Checkbox;
    checkboxCommodityExclude: Checkbox;
    checkboxExcludeApptStatus: Checkbox;
    daterangefilterOrders: DateRangeFilter;
    layoutProfileColor: ProfileColor;
    panelHeirarchy: Panel;
    panelLeft: Panel;
    panelRight: Panel;
    panelSwitchLeft: Panel;
    panelSwitchRight: Panel;
    sourceBrokeragePlanningProfile: DataSource;
    switchDisplayUntilReadyToBill: Switch;
    switchExactLaneMatch: Switch;
    switchIncludeOnHoldManifest: Switch;
    switchIncludeOnHoldOrders: Switch;
    switchIncludePartialShipments: Switch;
    textboxAppointmentStatus: Textbox;
    textboxBrkQualProfile: Textbox;
    textboxBrkQualStatus: Textbox;
    textboxBrokerageStatus: Textbox;
    textboxCommodity: Textbox;
    textboxDefaultDestFilter: Textbox;
    textboxDefaultOriginFilter: Textbox;
    textboxDispatcherUserId: Textbox;
    textboxId: Textbox;
    textboxIntSearchProfileId: Textbox;
    textboxOperationsUser: Textbox;
    textboxOrderCustomers: Textbox;
    textboxOrderIbType: Textbox;
    textboxOrderIbZones: Textbox;
    textboxOrderObType: Textbox;
    textboxOrderObZones: Textbox;
    textboxOrderRespCodes: Textbox;
    textboxOrderRespLevel: Textbox;
    textboxOrderSalesperson: Textbox;
    textboxOrderTrlrType: Textbox;
    textboxOrderType: Textbox;
    textboxRevenueCode: Textbox;
    textboxTitle: Textbox;
}
